import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";

const PartnerCommissionGroupDialog = ({
  open,
  onClose,
  partner,
  groups,
  onSubmit,
  saving,
}) => {
  const [commissionGroupId, setCommissionGroupId] = useState("");
  const [submitError, setSubmitError] = useState(null);

  const activeGroups = useMemo(
    () => groups.filter((g) => g.isActive !== false),
    [groups]
  );

  useEffect(() => {
    if (open && partner) {
      setCommissionGroupId(partner.commissionGroupId ?? "");
      setSubmitError(null);
    }
  }, [open, partner]);

  const handleSubmit = async () => {
    const result = await onSubmit(Number(commissionGroupId));
    if (result?.error) setSubmitError(result.error);
  };

  if (!partner) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تغییر گروه پورسانتی — #{partner.id}</DialogTitle>
      <DialogContent dividers>
        {submitError ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        ) : null}
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel>گروه پورسانتی</InputLabel>
          <Select
            value={commissionGroupId}
            label="گروه پورسانتی"
            onChange={(e) => setCommissionGroupId(e.target.value)}
          >
            {activeGroups.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.title} ({group.code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerCommissionGroupDialog;
